import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import Loader from '../ui/loader/Loader';

import { useUser } from '@/hooks/useUser';
import { AppRoutes } from '@/interfaces/routes/AppRoutes';
import { notificationService } from '@/services/notification.service';

const AdminGuard = () => {
	const { user, isLoading } = useUser();
	const userIsAdmin = user?.roles.includes('admin');

	useEffect(() => {
		if (!userIsAdmin) {
			notificationService.error(
				'You do not have permission to access this page',
			);
		}
	}, [userIsAdmin]);

	if (isLoading) {
		return (
			<Loader className="flex items-center justify-center h-full w-full" />
		);
	}

	if (!userIsAdmin) {
		return <Navigate to={AppRoutes.UserDashboard} />;
	}

	return <Outlet />;
};

export default AdminGuard;
